import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import { useSelector } from 'react-redux';
import { createLink, _t } from 'utils';
import moment from 'moment';
import Shared from 'screens/shared';
import CreateForm from 'screens/alb/create';
import CreateForwardingRule from 'screens/alb/create-forwarding-rule';
import { ROUTE } from 'constant';
import { ACTIONS_TYPES } from 'redux/helper';

export default ({ history, match }) => {
  const { dcId, id } = match.params;
  const { [ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.GET]: alb = {} } = useSelector((e) => e);
  const { entities = {}, properties = {}, metadata = {} } = alb;

  useEffect(() => {
    actions.applicationLoadbalancer.get({ dcId, id });
  }, [dcId, id]);

  const propertiesRows = [
    ['Listener Lan', <Shared.utilities.LAN id={properties?.listenerLan} />],
    ['Listener IPs', <Shared.utilities.IPs ips={properties?.ips || []} />],
    ['Target Lan', <Shared.utilities.LAN id={properties?.targetLan} />],
    ['Target IPs', <Shared.utilities.IPs ips={properties?.lbPrivateIps || []} />],
    ['Created Date', moment(metadata?.createdDate).fromNow()],
    [_t('Last Updated'), moment(metadata?.lastModifiedDate).fromNow()],
  ];

  const deleteHandler = () => {
    actions.applicationLoadbalancer.delete();
    history.goBack();
  };

  const clickHandler = (e) => history.push(createLink(ROUTE.DASHBOARD.ALB_FORWARDING_RULE, { dcId, albId: id, id: e.id }));

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.APPLICATION_LOAD_BALANCER}
      strapTitle={properties?.name}
      strapIcon="sitemap"
      onDelete={deleteHandler}
      editForm={<CreateForm item={{ id, ...properties }} isEdit />}
      editAction={ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.UPDATE}
    >
      <Shared.widgets.Properties properties={propertiesRows} />
      <Shared.widgets.Section
        className="p-t-12"
        itemIcon="angle-double-right"
        itemOnClick={clickHandler}
        createForm={<CreateForwardingRule />}
        createActionType={ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.CREATE_FORWARDING_RULE}
        sectionTitle="Forwarding Rules"
        items={entities?.forwardingrules?.items || []}
        setItemTitle={({ properties: e }) => e?.name}
        // eslint-disable-next-line
        setItemDetails={({ properties: e }) => <>IP <span className="color-base">{e?.listenerIp}</span> - Port <span className="color-base">{e?.listenerPort}</span></>}
      />

      {/* <Shared.widgets.Section
        className="p-t-24"
        itemIcon="exchange-alt"
        // itemOnClick={clickHandler}
        // onCreateClick={addHandler}
        sectionTitle="Flowlog"
        // items={entities?.forwardingrules?.items || []}
        setItemTitle={({ properties: e }) => e?.name}
        // eslint-disable-next-line
        setItemDetails={({ properties: e }) => <>IP <span className="color-base">
        {e?.listenerIp}
        </span> - Port <span className="color-base">{e?.listenerPort}</span></>}
      /> */}
    </Shared.widgets.Page>
  );
};
